import React from 'react';
import './StatementExport.css';

// SVG Icons for export formats
const PdfIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="export-icon pdf-icon">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(220, 38, 38, 0.1)"/>
    <polyline points="14,2 14,8 20,8" stroke="#dc2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <text x="12" y="15" fontSize="6" fill="#dc2626" textAnchor="middle" fontWeight="bold">PDF</text>
  </svg>
);

const CsvIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="export-icon csv-icon">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(5, 150, 105, 0.1)"/>
    <polyline points="14,2 14,8 20,8" stroke="#059669" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 11h8M8 13h8M8 15h8M8 17h6" stroke="#059669" strokeWidth="1" strokeLinecap="round"/>
    <text x="12" y="19" fontSize="5" fill="#059669" textAnchor="middle" fontWeight="bold">CSV</text>
  </svg>
);

const DetailedCsvIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="export-icon detailed-csv-icon">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(8, 145, 178, 0.1)"/>
    <polyline points="14,2 14,8 20,8" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 10h8M8 12h8M8 14h8M8 16h8M8 18h6" stroke="#0891b2" strokeWidth="1" strokeLinecap="round"/>
    <circle cx="17" cy="11" r="1" fill="#0891b2"/>
    <text x="12" y="20" fontSize="4" fill="#0891b2" textAnchor="middle" fontWeight="bold">CSV+</text>
  </svg>
);

const ExcelIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="export-icon excel-icon">
    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="rgba(22, 163, 74, 0.1)"/>
    <polyline points="14,2 14,8 20,8" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="8" y="10" width="8" height="6" stroke="#16a34a" strokeWidth="1" fill="none"/>
    <path d="M12 10v6M8 13h8" stroke="#16a34a" strokeWidth="1"/>
    <text x="12" y="19" fontSize="5" fill="#16a34a" textAnchor="middle" fontWeight="bold">XLS</text>
  </svg>
);

const LoadingSpinner = () => (
  <svg className="export-spinner" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="#e5e7eb" strokeWidth="3" />
    <path d="M12 2a10 10 0 0 1 10 10" stroke="#3b82f6" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

function StatementExport({ onExport, disabled, exporting }) {
  const exportFormats = [
    { id: 'pdf', label: 'PDF', IconComponent: PdfIcon },
    { id: 'csv', label: 'CSV', IconComponent: CsvIcon },
    { id: 'csv-detailed', label: 'Detailed CSV', IconComponent: DetailedCsvIcon },
    { id: 'excel', label: 'Excel', IconComponent: ExcelIcon }
  ];

  return (
    <div className="statement-export">
      <div className="export-buttons">
        {exportFormats.map(format => {
          const { IconComponent } = format;
          const isExporting = exporting === format.id;
          return (
            <button
              key={format.id}
              className={`export-button ${isExporting ? 'exporting' : ''}`}
              onClick={() => onExport(format.id)}
              disabled={disabled || exporting}
              title={isExporting ? 'Exporting...' : `Export as ${format.label}`}
            >
              {isExporting ? <LoadingSpinner /> : <IconComponent />}
              <span className="export-label">{isExporting ? 'Exporting...' : format.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default StatementExport;